import * as React from 'react';

import {
  StyledDotsContainer,
  StyledLabel,
  StyledDotOuter,
  StyledDotInner,
  StyledInput
} from './styles';

const ButtonRadio = ({
  field: {
    name, value, onChange, onBlur
  },
  formValue,
  id,
  label,
  className,
  box,
  light,
  noBorder,
  ...props
}) => (
  <StyledLabel className={className}>
    <StyledInput
      name={name}
      id={id}
      type="radio"
      value={formValue || id}
      checked={id === value || formValue === value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
    <StyledDotsContainer box={box}>
      <StyledDotOuter box={box} light={light} noBorder={noBorder} />
      <StyledDotInner box={box} />
    </StyledDotsContainer>
    {label}
  </StyledLabel>
);

export default ButtonRadio;
